
const formatMoney = (amount, asFloat) => {
    if (typeof amount !== 'number' && typeof amount !== 'string') return asFloat ? 0 : "0.00";
    if (typeof amount === "string" && !amount) return asFloat ? 0 : "0.00";
    if (typeof amount === "string") amount = parseFloat(amount);
    if (asFloat) return amount;
    return amount.toFixed(2);
};
export default formatMoney;